import { gql, useQuery } from '@apollo/client';
import type { ThingToDo } from 'apollo/generated/types';

const LIST_THINGS_TO_DO = gql`
  query listThingsToDo {
    listThingsToDo {
      id
      name
      description
      icon
      thingToDoImages {
        image
      }
    }
  }
`;
const EXCLUDED_THING_TO_DO_NAME = 'Balsa';

const useListThingsToDoQuery = () => {
  const result = useQuery<{ listThingsToDo: ThingToDo[] }>(LIST_THINGS_TO_DO, {});
  const data =
    result.data !== undefined
      ? {
          ...result.data,
          listThingsToDo: result.data.listThingsToDo.filter(
            (item) => item.name !== EXCLUDED_THING_TO_DO_NAME
          ),
        }
      : undefined;

  return {
    ...result,
    data,
  };
};
export default useListThingsToDoQuery;
